import { render, staticRenderFns } from "./ProjectApproved.vue?vue&type=template&id=77ad63f2&scoped=true"
import script from "./ProjectApproved.vue?vue&type=script&lang=js"
export * from "./ProjectApproved.vue?vue&type=script&lang=js"
import style0 from "./ProjectApproved.vue?vue&type=style&index=0&id=77ad63f2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ad63f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VForm,VLayout})
